import { useCallback, useEffect, useState } from 'react';
import SiteNavbar from '@/components/feature/SiteNavbar';
import SiteFooter from '@/components/feature/SiteFooter';
import BackToTop from '@/components/feature/BackToTop';
import Hero from './components/Hero';
import TrendingSection from './components/TrendingSection';
import CategorySection from './components/CategorySection';
import ArticleSection from './components/ArticleSection';
import CommunitySection from './components/CommunitySection';
import FaqSection from './components/FaqSection';
import SubscribeSection from './components/SubscribeSection';

const ALL = '全部';

export default function Home() {
  const [query, setQuery] = useState('');
  const [activeCategory, setActiveCategory] = useState(ALL);

  useEffect(() => {
    document.title = '黑吃瓜网 - 吃瓜群众热议话题与瓜友交流聚集地';
    const meta = document.querySelector('meta[name="description"]');
    if (meta) {
      meta.setAttribute(
        'content',
        '黑吃瓜网是吃瓜群众的聚集地，聚合今日热议话题、最新娱乐瓜料与话题分类，这里是瓜友交流、追热点的讨论区。',
      );
    }
  }, []);

  const scrollToArticles = useCallback(() => {
    const el = document.getElementById('articles');
    if (!el) return;
    const top = el.getBoundingClientRect().top + window.scrollY - 80;
    window.scrollTo({ top, behavior: 'smooth' });
  }, []);

  const handleSearch = useCallback(
    (keyword: string) => {
      setQuery(keyword);
      setActiveCategory(ALL);
      scrollToArticles();
    },
    [scrollToArticles],
  );

  const handleSelectCategory = useCallback(
    (category: string) => {
      setActiveCategory(category);
      setQuery('');
      scrollToArticles();
    },
    [scrollToArticles],
  );

  return (
    <div className="min-h-screen bg-background-50 flex flex-col">
      <SiteNavbar />
      <main className="flex-1">
        <Hero onSearch={handleSearch} />
        <TrendingSection />
        <CategorySection onSelectCategory={handleSelectCategory} />
        <ArticleSection
          query={query}
          activeCategory={activeCategory}
          onCategoryChange={setActiveCategory}
          onQueryChange={setQuery}
        />
        <CommunitySection />
        <FaqSection />
        <SubscribeSection />
      </main>
      <SiteFooter />
      <BackToTop />
    </div>
  );
}